import { UUID } from '@indigohive/cogfy-types'
import { CircleXIcon, UploadIcon } from 'lucide-react'
import { ChangeEvent, useRef } from 'react'
import { Button } from '../../../Button'
import { useUpload } from '../../../../field-types/FieldCell/components/FileCell/hooks/useUpload'
import { useCogfy } from '../../../../hooks'

export type FileFormInputUploadButtonProps = {
  collectionId: UUID
  fieldId: UUID
  onDelete: () => void
  onSuccess: (file: { id: UUID, name: string }) => void
  value?: {
    fileId?: UUID
    fileName?: string
  }
}

export function FileFormInputUploadButton (props: FileFormInputUploadButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  const client = useCogfy()
  const upload = useUpload(client, {
    collectionId: props.collectionId,
    fieldId: props.fieldId,
    scope: 'field',
    onProgress: () => {}
  })

  const handleClick = () => {
    inputRef.current?.click()
  }

  const handleDeleteClick = () => {
    props.onDelete()
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    event.target.value = ''

    if (file) {
      upload.mutate(file, {
        onSuccess: result => {
          if (result) {
            props.onSuccess({ id: result.id, name: result.name })
          }
        }
      })
    }
  }

  return (
    <>
      <input
        type="file"
        ref={inputRef}
        className="hidden"
        onChange={handleChange}
      />
      {props.value?.fileName && (
        <Button
          onClick={handleDeleteClick}
          ghost
          size="sm"
          square
        >
          <CircleXIcon size={16} />
        </Button>
      )}
      {!props.value?.fileName && (
        <Button
          onClick={handleClick}
          disabled={upload.isPending}
          ghost
          size="sm"
          square
        >
          <UploadIcon size={16} />
        </Button>
      )}
    </>
  )
}
